/**
 * Fiscal display window for the performance-detail screen.
 * targetYear = 対象年 (closing year), targetMonth = 決算月 (closing month, 1-based).
 * Window = the 12 months ENDING at targetYear/targetMonth.
 * e.g. (2026, 3) → 2025/04–2026/03; (2026, 12) → 2026/01–2026/12; (2026, 1) → 2025/02–2026/01.
 * Mirrors the backend getFiscalYearRange semantics so labels match the queried data.
 */
export type TPerformanceDetailPeriod = {
  startYear: number;
  startMonth: number;
  endYear: number;
  endMonth: number;
  rangeLabel: string; // e.g. "2025年4月-2026年3月"
};

export const getPerformanceDetailPeriod = (targetYear: number, targetMonth: number): TPerformanceDetailPeriod => {
  const startMonth = (targetMonth % 12) + 1; // month after the closing month (wraps 12→1)
  const startYear = startMonth > targetMonth ? targetYear - 1 : targetYear;
  return {
    startYear,
    startMonth,
    endYear: targetYear,
    endMonth: targetMonth,
    rangeLabel: `${startYear}年${startMonth}月-${targetYear}年${targetMonth}月`,
  };
};
